const LADHS_AGENCY_ID = 2462;

const affiliationHelpers = {
  /**
   * Groups the organizations an SSO network offers into the option groups shown to SAML members.
   * `suggestedAffiliation` is the member's parent agency; `affiliationList` its child agencies
   * (null when the agency has a parent of its own).
   *
   * Returns [] when there is no parent agency to build groups from, so callers render an empty
   * list rather than an option pointing at an undefined organization.
   */
  organizeSubunits: (suggestedAffiliation, affiliationList) => {
    if (!suggestedAffiliation?.id) return [];

    const subunits = affiliationList || [];

    if (suggestedAffiliation.id === LADHS_AGENCY_ID) {
      return [
        { title: 'Health Centers', subunits },
        { title: 'Other DHS', subunits: [{ id: suggestedAffiliation.id, name: 'HSA or Other', affiliation_name: suggestedAffiliation.name }] }
      ];
    }

    return [
      { title: 'Facilities', subunits },
      { title: 'Main Agency', subunits: [{ id: suggestedAffiliation.id, name: suggestedAffiliation.name }] }
    ];
  },

  /** The name an affiliation is stored under — subunits may display a label that differs from the org name. */
  affiliationNameFor: (subunit) => subunit?.affiliation_name || subunit?.name
};

export default affiliationHelpers;
